/**
 * CookingOverlayDemo
 * 
 * Shows cook-img.PNG with SVG overlays positioned on top.
 * Navigate to /cooking-demo to screenshot for demos.
 */

import React from 'react';
import './FeatureShowcase.css';

// Your actual cooking image
import cookImg from './assets/cook-img.PNG';

// SVG Overlays
import recipeStages from './assets/overlays/recipe-stages-overlay.svg';
import miseChecklist from './assets/overlays/mise-checklist-overlay.svg';
import dishData from './assets/overlays/dish-data-overlay.svg';
import flavorRadar from './assets/overlays/flavor-radar-overlay.svg';
import labelHerbs from './assets/overlays/label-fresh-herbs.svg';
import labelFlatbread from './assets/overlays/label-flatbread.svg';
import labelFilling from './assets/overlays/label-savory-filling.svg';
import labelSpices from './assets/overlays/label-spice-blends.svg';

const CookingOverlayDemo = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#030308',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
      }}
    >
      {/* Main container with image and overlays */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: '1100px',
        }}
      >
        {/* Base Image */}
        <img
          src={cookImg}
          alt="Cooking"
          style={{
            width: '100%',
            height: 'auto',
            borderRadius: '20px',
            display: 'block',
          }}
        />

        {/* Recipe Stages - Top Left */}
        <img
          src={recipeStages}
          alt=""
          style={{
            position: 'absolute',
            top: '24px',
            left: '24px',
            width: '220px',
          }}
        />

        {/* Mise Checklist - Top Right */}
        <img
          src={miseChecklist}
          alt=""
          style={{
            position: 'absolute',
            top: '24px',
            right: '24px',
            width: '200px',
          }}
        />

        {/* Dish Data - Below Mise Checklist */}
        <img
          src={dishData}
          alt=""
          style={{
            position: 'absolute',
            top: '260px',
            right: '24px',
            width: '180px',
          }}
        />

        {/* Flavor Radar - Bottom Left */}
        <img
          src={flavorRadar}
          alt=""
          style={{
            position: 'absolute',
            bottom: '24px',
            left: '24px',
            width: '200px',
          }}
        />

        {/* Ingredient Labels - Positioned around the food */}
        <img
          src={labelHerbs}
          alt=""
          style={{
            position: 'absolute',
            bottom: '45%',
            left: '25%',
            width: '160px',
          }}
        />

        <img
          src={labelFlatbread}
          alt=""
          style={{
            position: 'absolute',
            bottom: '40%',
            left: '42%',
            width: '150px',
          }}
        />

        <img
          src={labelFilling}
          alt=""
          style={{
            position: 'absolute',
            bottom: '35%',
            left: '55%',
            width: '150px',
          }}
        />

        <img
          src={labelSpices}
          alt=""
          style={{
            position: 'absolute',
            bottom: '30%',
            right: '15%',
            width: '160px',
          }}
        />
      </div>
    </div>
  );
};

export default CookingOverlayDemo;
